import { extractAllowedOptions } from '@/shared/components/form/config-value';
import type { ConfigSetting } from '@/features/products/types/products.types';

const METHODS_KEY = 'available_scheduling_methods';

interface RuleCarrier {
    validation_rules?: Record<string, unknown> | null;
}

export const requiredSchedulingMethod = (option: RuleCarrier | null | undefined): string | null => {
    const required = option?.validation_rules?.requires_scheduling_method;
    return typeof required === 'string' && required !== '' ? required : null;
};

export const configuredSchedulingMethods = (settings: ConfigSetting[]): string[] => {
    const row = settings.find((s) => s.key === METHODS_KEY);
    if (!row || !Array.isArray(row.value)) return [];
    return row.value.filter((v): v is string => typeof v === 'string');
};

export const isOptionApplicable = (option: RuleCarrier, methods: readonly string[]): boolean => {
    const required = requiredSchedulingMethod(option);
    return required === null || methods.includes(required);
};

export const schedulingMethodLabeller = (settings: ConfigSetting[]): ((key: string) => string) => {
    const allowed = extractAllowedOptions(settings.find((s) => s.key === METHODS_KEY)?.configOption);
    return (key) => allowed.find((a) => a.value === key)?.label ?? key;
};

export const inapplicableSettingNote = (
    setting: ConfigSetting,
    methods: readonly string[],
    methodLabel: (key: string) => string,
): string | null => {
    const option = setting.configOption;
    if (!option || isOptionApplicable(option, methods)) return null;
    const label = methodLabel(requiredSchedulingMethod(option) as string);
    return `Not in effect: requires ${label} in Available Scheduling Methods. Delete this setting or enable ${label}.`;
};
